module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-card-title"
  }, [_c('span', {
    staticClass: "graph-card-title__primary"
  }, [_vm._v("\n      Specific Conductivity (µS)\n      "), _c('v-dialog', {
    attrs: {
      "content-class": "nww-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.controls.conductiveDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "conductiveDialog", $$v)
      },
      expression: "controls.conductiveDialog"
    }
  }, [_c('i', {
    staticClass: "material-icons graph-card-title__icon",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n          info_outline\n        ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Specific Conductivity (µS)")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Specific Conductivity (conductivity) is a measure of the water’s ability to pass an electrical current and indicates the presence of ions. Sources of ions in streams include nutrients, heavy metals, and salts from urban and agricultural runoff, or minerals from rock weathering. Background levels of conductivity in streams in Georgia range from 50 – 1500 µS/cm. We closely monitor any deviations in conductivity at each site we monitor.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.controls.conductiveDialog = false
      }
    }
  }, [_vm._v("Okay")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "graph-card-title__secondary--strong"
  }, [_vm._v("\n        Last Result:\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "graph-card-title__secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedSite ? _vm.selectedSite.lastConductivityResult : null) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "graph-card__graph-wrapper"
  }, [_c('vue-highcharts', {
    ref: "conductivityChart",
    attrs: {
      "id": "chart4",
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a78774"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/panels/ConductivityChart.vue
// module id = 438
// module chunks = 1